import _ from 'lodash';
import withProbability from '../lib/withProbability';
import randomizeStartingNote from '../lib/randomizeStartingNote';
import lastNotesAreAll from '../lib/lastNotesAreAll';
import Note from '../Note';

export default (programmer, instrument) => {
  const times = Math.round(3 + (Math.random() * 2));
  const halfAnOctave = Math.round(programmer.octaveLength / 2);

  const nextOptions = [
    0,
    0+1,
    0-1,
    0+2,
    0-2,
    0+3,
    0+halfAnOctave,
    0-halfAnOctave,
    0+programmer.octaveLength,
    0-programmer.octaveLength
  ];

  function getNewNote(lastPlayed, history, allowEmptyNote, programmer) {

    const options = nextOptions.reduce( (output, o) => {
      const result = lastPlayed.noteIndex + o;
      // If the note for this possible option doesn't exist, there is a chance
      // that we add an octave-shifted option.
      if (result < 0) {
        if (withProbability(.5)) output.push(result + programmer.octaveLength);
      } else if (result > (instrument.notes.length - 1)) {
        if (withProbability(.5)) output.push(result - programmer.octaveLength);

      // If the note does exist, and doesn't repeat, we can add it as an option
      } else if (!lastNotesAreAll(history, 2, result)) {
        output.push(result)
      }

      return output;
    }, []);

    if (!options.length) throw new Error('no options!');
    const newNoteIndex = _.sample(options);

    return new Note(newNoteIndex, instrument);
  }

  const currentSegment = [];
  const lastPlayed = _.last(instrument.history);

  const startingNote = randomizeStartingNote(lastPlayed && lastPlayed.noteIndex, instrument, programmer);
  let lastNote = startingNote;

  _.times(times, i => {
    const allowEmptyNote = i > 0 && i < (times - 1) && !_.some(history, _.isNull)
    const newNote = getNewNote(lastNote, currentSegment, allowEmptyNote, programmer);

    currentSegment.push(newNote);
  });

  return currentSegment;
}



// WEBPACK FOOTER //
// ./src/patternGenerators/random.js